<template>
<section>
    <div class="hot-container">
        <div class="avatar">
            <img src="../assets/images/hotservice.png" alt="">
        </div>
        <p class="line">客服热线</p>
        <p class="time">400-669-3600转2 时间：8:30-20:30</p>
    </div>
    <div class="cover" @click="$emit('input', false)"></div>
</section>
    
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .hot-container {
        width: 468px;
        height: 444px;
        position: fixed;
        top: 404px;
        left: 142px;
        background: white;
        padding: 60px 106px;
        z-index: 200;
        box-sizing: border-box;
        font-weight: 600;
        .avatar {
            height: 144px;
            text-align: center;
            img {
                width: 144px;
            }
        }
        .line {
            margin-top: 24px;
            margin-bottom: 24px;
            text-align: center;
        }
        .time {
            line-height: 1.5;
        }
    }
    .cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  opacity: 0.4;
  z-index: 100;
}
</style>